import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "mb-2 flex flex-wrap gap-1" }
const _hoisted_3 = { class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600" }
const _hoisted_4 = {
  key: 0,
  class: "rounded bg-catering-honey-100 px-1.5 py-0.5 text-[11px] font-medium text-catering-honey-600"
}
const _hoisted_5 = {
  key: 1,
  class: "rounded bg-catering-berry-100 px-1.5 py-0.5 text-[11px] font-medium text-catering-berry-600"
}
const _hoisted_6 = { class: "divide-y divide-catering-cream-300" }
const _hoisted_7 = { class: "min-w-0 truncate" }
const _hoisted_8 = { class: "min-w-0 truncate" }
const _hoisted_9 = {
  key: 0,
  class: "text-catering-ink-500"
}


export default {
  __name: 'BotInventoryReport',
  props: { block: { type: Object, required: true } },
  setup(__props) {


function statusClass(status) {
  if (status === 'out_of_stock') return 'text-catering-berry-600'
  if (status === 'low') return 'text-catering-honey-600'
  return 'text-catering-ink-500'
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Inventory", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.block.tracked_products) + " tracked ", 1),
      (__props.block.low)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.block.low) + " low ", 1))
        : _createCommentVNode("", true),
      (__props.block.out_of_stock)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.block.out_of_stock) + " out ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.products || [], (p, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: "flex items-center justify-between py-1 text-catering-ink-900"
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(p.name), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["shrink-0 tabular-nums", statusClass(p.status)])
          }, _toDisplayString(p.inventory_remaining), 3)
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.variant_options || [], (o, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: 'v' + i,
          class: "flex items-center justify-between py-1 text-catering-ink-700"
        }, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(o.product) + " · " + _toDisplayString(o.option), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["shrink-0 tabular-nums", statusClass(o.status)])
          }, _toDisplayString(o.inventory_remaining), 3)
        ]))
      }), 128))
    ]),
    (!(__props.block.products || []).length && !(__props.block.variant_options || []).length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Nothing is inventory-tracked — every product is unlimited. "))
      : _createCommentVNode("", true)
  ]))
}
}

}